import VerticalPage from "@/components/marketing/VerticalPage";
import { WifiOff, Zap, Truck, Receipt, Layers, Cpu } from "lucide-react";

export default function Expressways() {
  return (
    <VerticalPage
      vertical="Expressways"
      hero={"High-throughput POS for highway food courts that can't afford a queue."}
      blurb={"Travellers don't wait. Trucker dhabas, highway rest-stops, and expressway food plazas need ordering systems that work offline, settle in 60 seconds, and never lose a ticket — Grubpe was built for exactly that."}
      palette={{
        badge:  "bg-emerald-50 text-emerald-700",
        iconBg: "bg-emerald-50 text-emerald-700",
        kpi:    "bg-emerald-50 text-emerald-900 border border-emerald-200",
      }}
      kpis={[
        { value: "8h",     label: "Offline buffer" },
        { value: "60s",    label: "Cart to served" },
        { value: "0",      label: "Lost tickets" },
        { value: "24/7",   label: "Operation" },
      ]}
      features={[
        { icon: WifiOff,  title: "Offline-resilient POS",     desc: "8-hour offline cache, deterministic ticket IDs, zero-duplication merge when the internet returns. No more 'we lost the order' moments." },
        { icon: Zap,      title: "60-second tickets",          desc: "Pre-built combos, swipe-friendly POS UI, single-tap UPI / wallet / card — drivers in, drivers out, before the tea cools." },
        { icon: Truck,    title: "Fleet & corporate billing",  desc: "Trucking companies pre-load wallets for drivers. Spend reports per driver per route. Monthly aggregated invoices to fleet HQ." },
        { icon: Receipt,  title: "Auto-payouts to vendors",    desc: "Multi-vendor courts: each vendor sees their cash and digital tally live on their phone, gets paid weekly with zero negotiation." },
        { icon: Layers,   title: "Brand-aware menus",          desc: "Same hardware powers a McD-style QSR and a roadside thali joint — menu, branding, kitchen flow all configurable per outlet." },
        { icon: Cpu,      title: "Rugged hardware ready",      desc: "Runs on Android tablets, thermal printers, EDC terminals, and Bluetooth scales. No proprietary lock-in. Spare parts at the next exit." },
      ]}
      useCases={[
        "11 PM, no 4G: 38 tickets billed offline, queued locally; network returns at 11:18 PM, all 38 sync to cloud, KOTs reconciled.",
        "Fleet driver pulls in: scans his company card, ₹150 meal allowance auto-applied, balance billed to fleet HQ.",
        "Highway food court with 6 vendors: ₹3.2 L revenue Friday night, settled to each vendor by Saturday noon.",
        "Owner gets a WhatsApp anomaly alert: ‘North-bound exit revenue down 27% — check counter 2 hardware’.",
      ]}
    />
  );
}
